// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/TailorDateField/Hiddenelements.story.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {TailorDateField} from '@sail/ui';

export const Hiddenelements = () => (
  <TailorDateField
    label="Date of birth"
    description="Enter your birthday"
    defaultValue="2011-09-01"
    hiddenElements={['description', 'label']}
  />
);
